import { render, staticRenderFns } from "./cancelwaiting.vue?vue&type=template&id=1977d30b&scoped=true&"
import script from "./cancelwaiting.vue?vue&type=script&lang=js&"
export * from "./cancelwaiting.vue?vue&type=script&lang=js&"
import style0 from "./cancelwaiting.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cancelwaiting.vue?vue&type=style&index=1&id=1977d30b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977d30b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VCard,VFlex,VFooter,VIcon,VImg,VLayout,VSpacer,VToolbarTitle})
